import * as React from "react";
import CountUp from 'react-countup';
import Skeleton from 'react-loading-skeleton';

export class Statisic extends React.Component<{
    style?: React.CSSProperties

    icon?: string
    value?: number | string
    title?: string

    loading?: boolean

    renderContent?: () => React.ReactNode
}> {

    constructor(p: any) {
        super(p);
        this.state = {
        }
    }

    renderContent() {
        if (this.props.renderContent) {
            return this.props.renderContent()
        }
        const { title, value, loading } = this.props
        return <>
            <div className='value'>{(loading || value == undefined) ? <Skeleton width={80} /> : <CountUp end={typeof value == 'string' ? parseInt(value) : value} duration={1.5} useEasing />}</div>
            {title && <div className='title'>{title}</div>}
        </>
    }

    render() {
        const { style, icon } = this.props
        return <div className='statistic' style={style}>
            <div className='statistic-container' style={style}>
                {icon && <div className='icon-conainer'>
                    <img src={icon} />
                </div>}
                <div className='stat-conainer'>
                    {this.renderContent()}
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Statistic.tsx